(() => {
  const waitForSwiper = () =>
    new Promise((resolve) => {
      if (window.Swiper) {
        resolve(window.Swiper);
        return;
      }

      const started = Date.now();
      const timer = window.setInterval(() => {
        if (window.Swiper) {
          window.clearInterval(timer);
          resolve(window.Swiper);
          return;
        }

        if (Date.now() - started > 5000) {
          window.clearInterval(timer);
          resolve(null);
        }
      }, 50);
    });

  const hasReadySlides = (swiperEl) => {
    const slides = swiperEl?.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide');
    if (!slides?.length) return false;

    return Array.from(slides).some(
      (slide) =>
        !slide.classList.contains('visually-invisible') &&
        slide.getAttribute('aria-hidden') !== 'true'
    );
  };

  const initSlider = async (root) => {
    const swiperEl = root.querySelector('[data-mcc-recommendations-swiper]');
    if (!swiperEl || !hasReadySlides(swiperEl)) return;

    const Swiper = await waitForSwiper();
    if (!Swiper) return;

    if (root._mccRecommendationsSwiper) {
      root._mccRecommendationsSwiper.destroy(true, true);
      root._mccRecommendationsSwiper = null;
    }

    root._mccRecommendationsSwiper = new Swiper(swiperEl, {
      slidesPerView: 1.5,
      spaceBetween: 40,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        990: {
          enabled: false,
          slidesPerView: 5,
          spaceBetween: 25,
        },
      },
    });
  };

  const initSection = (root) => {
    const host = root.closest('product-recommendations');
    if (host?.classList.contains('hide')) return;

    initSlider(root);
  };

  const boot = () => {
    document.querySelectorAll('[data-mcc-product-recommendations]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('recommendations:loaded', (event) => {
    const root = event.detail?.section?.querySelector?.('[data-mcc-product-recommendations]');
    if (root) initSection(root);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('[data-mcc-product-recommendations]');
    if (root) initSection(root);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector?.('[data-mcc-product-recommendations]');

    if (root?._mccRecommendationsSwiper) {
      root._mccRecommendationsSwiper.destroy(true, true);
      root._mccRecommendationsSwiper = null;
    }
  });
})();
